import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=19f86c64&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=19f86c64&prod&lang=css"
import style1 from "./Add.vue?vue&type=style&index=1&id=19f86c64&prod&lang=scss&scoped=true"
import style2 from "./Add.vue?vue&type=style&index=2&id=19f86c64&prod&lang=css"
import style3 from "spinkit/scss/spinkit.scss?vue&type=style&index=3&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f86c64",
  null
  
)

export default component.exports